export default "__VITE_ASSET__CE2e1WQ4__"